import React from "react";
import { Account } from "model";
import "./styles.css";

/**
* @function FastBalanceAccountView
* @param {STRING} accountNickname - The Account Nickname
* @param {STRING} accountBalance - The Account Balance
* @param {STRING} accountLastFour - The Account Number Last Four Digits
* @param {STRING} accountType - The Account Type
* @param {STRING} accountCurrentBalance - the Account Current Balance
* @return {React.Component}
* @exported true
* @description The FastBalanceAccountView is the view for showing account balances.
* @example
* <FastBalanceAccountView accountNickname="Main Checking" accountBalance="$X.XX" accountLastFour="x1234" accountType="Checking" accountCurrentBalance="$X.XX" />
*/
export default function FastBalanceAccountView(props) {
    const account = props.account ?? {};
    const accountType = account.type ? account.type.charAt(0).toUpperCase() + account.type.slice(1) : "checking";

    return (
        <div className="fast-balance-account-view">
            <div className="flex-container flex-horizontal align-center account-nickname-balance-container">
                <div className="flex-width">
                    <p className="account-nickname">{ account.nickname }</p>
                </div>
                <div className="flex-width">
                    <p className="amount text-right">{ Account.isLOC(account) ? account.availableCredit.format() : account.availableBalance.format() }</p>
                </div>
            </div>
            <div className="flex-container flex-horizontal align-center account-number-current-balance-container">
                <div className="flex-width">
                    <p className="account-information sub-text">{ account.number } | { accountType }</p>
                </div>
                <div className="flex-width">
                    <p className="current-amount sub-text text-right">Current { account.currentBalance.format() }</p>
                </div>
            </div>
        </div>
    );

}
